import { shallowMount } from "@vue/test-utils";
import GraciasCajaAhorro from "@/views/GraciasCajaAhorro";

describe("GraciasCajaAhorro component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(GraciasCajaAhorro);
  });

  it("Renders del component GraciasCajaAhorro", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
